import { ReactNode } from "react";

type LazySectionProps = {
  children: ReactNode;
  rootMargin?: string;
  minHeightClassName?: string;
};

export function LazySection({
  children,
  rootMargin = "320px",
  minHeightClassName = "min-h-[220px]",
}: LazySectionProps) {
  return (
    <div
      className={`${minHeightClassName} w-full`}
      style={{
        contentVisibility: "auto",
        containIntrinsicSize: rootMargin,
      }}
    >
      {children}
    </div>
  );
}
